module.exports = __webpack_public_path__ + "img/diamond_bonus-ar.b0cc6950.png";